let language = {
    CATALOG_PRODUCT_SORT_RECOMMENDED:"Recommended",
    CATALOG_PRODUCT_SORT_NEW:"New",
    CATALOG_PRODUCT_SORT_PRICE:"Price",
    CATALOG_PRODUCT_SORT_PRICE_LOW:"Low - High",
    CATALOG_PRODUCT_SORT_PRICE_HIGH:"High - Low",
    CATALOG_PRODUCT_SEARCH_FOR:"Search for",
    CATALOG_PRODUCT_NAV_HEAD:"Products",
    CATALOG_PRODUCT_EMPTY:"The catalog products is empty.",
    CATALOG_PRODUCT_LOW_PRICE:"as low as",
    CATALOG_PRODUCT_MORE_BTN:"more..."
};

export { language }